/**
 * Current default layout without redesign.
 *
 * @see https://jira.migros.net/browse/IHGWEBCC-2343
 */
const VARIANT_DEFAULT = 'A'

export default function useRedesignFeature() {
  const feature = useFeature('srp-redesign')
  const { isEnabled, variant } = feature

  const isRedesign = computed(
    () =>
      isEnabled.value &&
      variant.value && // if variant is not selected, the redesign is still disabled
      variant.value.name !== VARIANT_DEFAULT,
  )

  return { isRedesign, ...feature }
}
